var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCoding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8334 11.6665H8.16671C6.87804 11.6665 5.83337 12.7112 5.83337 13.9998V18.0832C5.83337 19.3718 6.87804 20.4165 8.16671 20.4165H47.8334C49.122 20.4165 50.1667 19.3718 50.1667 18.0832V13.9998C50.1667 12.7112 49.122 11.6665 47.8334 11.6665Z",
    fill: "#15C480"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 23.625H8.16671C6.87804 23.625 5.83337 24.6697 5.83337 25.9583V30.0417C5.83337 31.3303 6.87804 32.375 8.16671 32.375H15.1667C16.4554 32.375 17.5 31.3303 17.5 30.0417V25.9583C17.5 24.6697 16.4554 23.625 15.1667 23.625Z",
    fill: "#7666EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 35.583H8.16671C6.87804 35.583 5.83337 36.6277 5.83337 37.9163V41.9997C5.83337 43.2883 6.87804 44.333 8.16671 44.333H15.1667C16.4554 44.333 17.5 43.2883 17.5 41.9997V37.9163C17.5 36.6277 16.4554 35.583 15.1667 35.583Z",
    fill: "#7666EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6667 23.625H23.0417C21.753 23.625 20.7084 24.6697 20.7084 25.9583V30.0417C20.7084 31.3303 21.753 32.375 23.0417 32.375H39.6667C40.9554 32.375 42 31.3303 42 30.0417V25.9583C42 24.6697 40.9554 23.625 39.6667 23.625Z",
    fill: "#9EEED3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 35.583H23.0417C21.753 35.583 20.7084 36.6277 20.7084 37.9163V41.9997C20.7084 43.2883 21.753 44.333 23.0417 44.333H31.5C32.7887 44.333 33.8334 43.2883 33.8334 41.9997V37.9163C33.8334 36.6277 32.7887 35.583 31.5 35.583Z",
    fill: "#9EEED3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7292 41.125H38.9375C38.0516 41.125 37.3334 41.8432 37.3334 42.7292C37.3334 43.6151 38.0516 44.3333 38.9375 44.3333H42.7292C43.6152 44.3333 44.3334 43.6151 44.3334 42.7292C44.3334 41.8432 43.6152 41.125 42.7292 41.125Z",
    fill: "#15C480"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoding);
export default __webpack_public_path__ + "static/media/icon_coding.fce63df2.svg";
export { ForwardRef as ReactComponent };